module.exports = __webpack_public_path__ + "img/jobs-reselect.e485b79e.svg";